import React from "react";
import { Modal, Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";

class ConfirmationDialog extends React.PureComponent {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        size="xs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.dialogApiError}
          {this.props.body}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className={`btn btn-${this.props.cancelButtonVariant}`}
            onClick={this.props.onHide}
          >
            {this.props.cancelButtonText ? this.props.cancelButtonText : this.props.t("DialogCancel")}
          </Button>
          <Button
            className={`btn btn-${this.props.confirmButtonVariant}`}
            onClick={() => this.props.onSubmit()}
          >
            {this.props.confirmButtonText ? this.props.confirmButtonText : this.props.t("DialogConfirm")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(ConfirmationDialog);
